const state = () => ({
	taskItem: null,
	serviceRef: null,
	ccNoteRef: null,
	reRenderCount: 0,
	company: null,
})

const getters = {
	getTaskItem: state => state.taskItem,
}

const mutations = {
	setTaskItem: (state, payload) => {
        state.taskItem = payload;
    },
	setServiceRef: (state, payload) => {
        state.serviceRef = payload;
    },
	setCcNoteRef: (state, payload) => {
        state.ccNoteRef = payload;
    },
	incrementReRenderCount: (state) => {
        state.reRenderCount += 1;
    },
	setCompany: (state, payload) => {
        state.company = payload;
    },
}

export default {
	namespaced: true,
	state,
	getters,
	mutations
}